export default __webpack_public_path__ + "static/thumbnail_printing-914c06dd04203b9e03a1af04a1c48f12.png";